// The Allure report iframe loads `/api/proxy/allure/t/<token>/...`, where `<token>` is a limited
// user token valid for about an hour. Datadog RUM records resource and view URLs (and session
// replay the iframe's `src`), which would send that token to a third party, so it is rewritten
// before an event leaves the browser.
const TOKEN_SEGMENT = /(\/allure\/t\/)[^/?#"'\s]+/g;

export function redactAllureToken(text: string): string {
  return text.replace(TOKEN_SEGMENT, '$1<redacted>');
}

/**
 * Rewrites the token in every string of a RUM event, in place. Datadog applies only changes to
 * the fields it lets `beforeSend` modify (`resource.url`, `view.url`, `view.referrer`, ...) and
 * ignores the rest, so walking the whole event is both complete and safe.
 */
export function redactAllureTokenInEvent(value: unknown): void {
  if (Array.isArray(value)) {
    value.forEach((item, index) => {
      if (typeof item === 'string') {
        value[index] = redactAllureToken(item);
      } else {
        redactAllureTokenInEvent(item);
      }
    });
    return;
  }
  if (value && typeof value === 'object') {
    const record = value as Record<string, unknown>;
    for (const key of Object.keys(record)) {
      const item = record[key];
      if (typeof item === 'string') {
        record[key] = redactAllureToken(item);
      } else {
        redactAllureTokenInEvent(item);
      }
    }
  }
}
